import React from "react";
import styles from './PolicyBasic.module.css';

export default function PrivacyPolicyContentJotform(){
    return(
        <div className={styles.contentContainer}>
            <p>Last Updated: 19/09/2025</p>
            <br/>
            
            <h4>1. Introduction</h4>
            <div>
                <p>Stratela Ltd respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your information when you submit a form via Jotform.</p>
            </div>

            <h4>2. Information We Collect</h4>
            <div>
                <p>When you submit a form, we may collect the following personal information:</p>
                <p>Name and Email Address</p>
                <p>This information is necessary to process your request and send related communications.</p>
            </div>

            <h4>3. How We Use Your Information</h4>
            <div>
                <p>We use your personal information for the following purposes:</p>
                <p><span>Responding to Requests:</span> To process and respond to your form submission.</p>
                <p><span>Communication:</span> To send necessary confirmation or follow-up emails related to your submission.</p>
            </div>

            <h4>4. Legal Basis for Processing</h4>
            <div>
                <p>We process your information under the following legal bases:</p>
                <p><span>Contractual Necessity:</span> To provide the service or information you requested.</p>
                <p><span>Legitimate Interest:</span> To ensure we can communicate with you about your submission.</p>
            </div>

            <h4>5. Data Security</h4>
            <div>
                <p>We implement reasonable security measures to protect your personal information from unauthorized access, use, disclosure, or alteration. However, no method of data transmission or storage is entirely secure, and we cannot guarantee absolute security.</p>
            </div>

            <h4>6. Data Sharing</h4>
            <div>
                <p>We do not sell, rent, or trade your personal information. We may share it only with trusted service providers (such as form and email providers) who process data on our behalf under strict confidentiality obligations.</p>
            </div>

            <h4>7. Data Retention</h4>
            <div>
                <p>We retain your data only as long as necessary to fulfill the purpose for which it was collected or as required by law. Once no longer needed, it will be securely deleted.</p>
            </div>

            <h4>8. Your Rights</h4>
            <div>
                <p>You have the following rights regarding your personal information:</p>
                <p><span>Access:</span> You may request access to the personal information we hold about you.</p>
                <p><span>Correction:</span> You may request that we correct any inaccurate or incomplete personal information.</p>
                <p><span>Deletion:</span> You may request that we delete your personal information, subject to certain legal obligations.</p>
                <p><span>Withdrawal of Consent:</span> If you previously consented to additional uses of your data, you may withdraw consent at any time.</p>
                <p>To exercise these rights, please contact us at:</p>
                <p>it@stratela.co.uk</p>
            </div>

            <h4>9. Changes to this Privacy Policy</h4>
            <div>
                <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.</p>
            </div>

            <h4>10. Contact Us</h4>
            <div>
                <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
                <p>it@stratela.co.uk</p>
            </div>
        </div>

    )
}